import { connect } from 'react-redux'
import { RouteProps } from 'react-router'
import styled from 'styled-components'

import MetaTags from 'components/meta/MetaTags'
import ScrollTop from 'components/utils/ScrollTop'
import { HeadingLg } from 'components/display/Typography'
import Container from 'components/layout/Container'
import NewPasswordForm from './NewPasswordForm'

const FormContainer = styled.div`
  padding: 24px 0 150px 0;
`

const NewPassword = ({ location }: { location: RouteProps['location'] }) => {
  return (
    <>
      <ScrollTop />
      <MetaTags title="Change password" />
      <Container width={640} paddingY={40}>
        <HeadingLg>Change your password</HeadingLg>
        <FormContainer>
          <NewPasswordForm location={location} />
        </FormContainer>
      </Container>
    </>
  )
}

export default connect()(NewPassword)
